import React from 'react'


function VirtualTour() {
  return (<div className='lg:ml-36 mb-20 xl:ml-[80px] mb-[20px] sm:mt-[25px] flex flex-col items-left lg:items-start text-left lg:text-left justify-center flex-1 px-4 lg:px-0' >
   <iframe style={{maxWidth: '100%', width: '100%', height: '430px'}} src="https://www.klapty.com/tour/tunnel/4Cl0nHdC18" frameborder={0} allowFullScreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowvr="true" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; vr" />
   
  </div>
  
  )
}


export default VirtualTour



